import { render } from "./HomeActionsBarSelectionTools.vue?vue&type=template&id=37b79510&scoped=true"
import script from "./HomeActionsBarSelectionTools.vue?vue&type=script&lang=js"
export * from "./HomeActionsBarSelectionTools.vue?vue&type=script&lang=js"

import "./HomeActionsBarSelectionTools.vue?vue&type=style&index=0&id=37b79510&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-37b79510"

export default script